import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import CssBaseline from '@mui/material/CssBaseline';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/AppBar": AppBar, "@mui/material/Toolbar": Toolbar, "@mui/material/Typography": Typography, "@mui/material/CssBaseline": CssBaseline, "@mui/material/useScrollTrigger": useScrollTrigger, "@mui/material/Box": Box, "@mui/material/Container": Container } } });
export default ClientProvider;
